/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Seo_Keywords_HintInputs */

const cs_form_seo_keywords_hint = /** @type {(inputs: Form_Seo_Keywords_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klíčová slova oddělená čárkou`)
};

const en_form_seo_keywords_hint = /** @type {(inputs: Form_Seo_Keywords_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comma-separated keywords`)
};

/**
* | output |
* | --- |
* | "Comma-separated keywords" |
*
* @param {Form_Seo_Keywords_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_seo_keywords_hint = /** @type {((inputs?: Form_Seo_Keywords_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Seo_Keywords_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_seo_keywords_hint(inputs)
	return cs_form_seo_keywords_hint(inputs)
});